import { render, staticRenderFns } from "./ListKeyItem.vue?vue&type=template&id=3880ea65&"
import script from "./ListKeyItem.vue?vue&type=script&lang=ts&"
export * from "./ListKeyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports